import { useEffect, useState } from "react";
import baseClient from "../../api/Base";
import ErrorMsg from "../Utils/errormsg";
import Loading from "../Utils/loading";
import toolsClient from "../../Javascript/Tools";
import Popover from "../Utils/popover";
import ProductForm from "./productform";

function Products({ fnClose }) {
  const [products, setProducts] = useState([]);
  const [errorMsg, setErrorMsg] = useState();
  const [loading, setLoading] = useState(false);
  const [editProduct, setEditProduct] = useState();
  const [refreshData, setRefreshData] = useState(true);

  useEffect(() => {
    try {
      const getProducts = async () => {
        setRefreshData(null);
        setLoading(true);
        const model = {};
        const result = await baseClient.APIPost({
          model: model,
          api: "getproducts",
        });
        if (!result || !result.code === 200) {
          setLoading(false);
          setErrorMsg({
            message: `Error getting products. Code: ${result?.code}`,
            title: "Oops",
          });
          return;
        }
        setProducts(result.data);
        setTimeout(() => {
          setLoading(false);
        }, toolsClient.LOADING_DELAY);
      };
      if (refreshData) {
        getProducts();
      }
    } catch (err) {
      setLoading(false);
      setErrorMsg({
        message: `Something went wrong loading products. ${err.message}`,
        title: "Oops",
      });
      console.error(err.message);
    }
  }, [refreshData]);

  return (
    <div>
      {loading ? <Loading /> : null}
      {errorMsg ? (
        <ErrorMsg
          title={errorMsg.title}
          message={errorMsg.message}
          position={`fixed`}
          fnClose={() => {
            setErrorMsg(null);
          }}
        />
      ) : null}
      {editProduct ? (
        <Popover
          title="Products"
          iconClass={`fa fa-money-check-dollar`}
          fnClose={() => {
            setRefreshData(true);
            setTimeout(() => {
              setEditProduct(null);
            }, 100);
          }}
        >
          <ProductForm
            fnClose={() => {
              setRefreshData(true);
              setTimeout(() => {
                setEditProduct(null);
              }, 100);
            }}
            id={editProduct}
          />
        </Popover>
      ) : null}
      <div className={`p-1`}>
        <div className={`p-1 align-center b-bottom`}>
          <h2>Products</h2>
          <div>Tips, Shoutouts and Live Feeds</div>
          <div className={`p-top-1`}>
            <button
              type="button"
              className={`anchor-button brand-link-color`}
              onClick={() => {
                setEditProduct("new");
              }}
            >
              <i className={`fa-solid fa-plus-circle m-right-05`} />
              Add New Product
            </button>
          </div>
        </div>
        {products.map((item, index) => {
          return (
            <div kdy={`prod${index}`} className={`p-05 b-bottom`}>
              <button
                type="button"
                className={`anchor-button brand-link-color`}
                onClick={() => {
                  setEditProduct(item._id);
                }}
              >
                {item.name}
              </button>
            </div>
          );
        })}
        <div className={`p-1 m-top-1 align-center`}>
          <button
            type="button"
            className={`button-close`}
            onClick={() => {
              fnClose();
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
export default Products;
